<template>
    <div class="jd-page--expert-list">
        <div class="topBar">
            <jd-shbar @search="search"></jd-shbar>
        </div>
        <k-hr size="88" />
        <k-tabs ref="main" v-model="active" @click="tabSelect" :sticky="true" :offset-top="barTop" class="jd-tabs">
            <k-tab title="全部">
                <div class="jd-tabs--content" v-show="active==0">
                    <router-link v-for="(item, index) in getAppraisersList(0)" :key="item.aid" :to="`/detail?aid=${item.aid}`"  class="jd-tab-con">
                        <appraiser-item :info="item" :good="true" :hr="true"></appraiser-item>
                    </router-link>
                </div>
            </k-tab>
            <template v-if="categoryTabs">
                <k-tab v-for="(item, index) in categoryTabs" :key="item.id" :title="item.name">
                    <div class="jd-tabs--content">
                        <router-link v-for="(itm, i) in getAppraisersList(item.id)" :key="itm.aid" :to="`/detail?aid=${itm.aid}`" class="jd-tab-con">
                            <appraiser-item :info="itm" :good="true" :hr="true"></appraiser-item>
                        </router-link>
                        <div class="k-nodata" v-if="!getAppraisersList(item.id).length">暂无数据！ </div>
                    </div>
                </k-tab>
            </template>
        </k-tabs>
        <div class="k-nodata" v-if="loading">数据加载中…</div>
        <k-hr />

        <k-pagination v-if="totalPage>0"
            v-model="currentPage"
            :page-count="pageCount"
            mode="simple"
            @change="pageChange"
        />
        <jd-tabbar />
    </div>
</template>

<script>
    import {mapActions, mapState, mapGetters} from "vuex"
    import {inMobile} from "../../utils/wz.v2"
    export default {
        name: "list",
        data() {
            return {
                currentPage     : 2,
                active          : +this.$route.query.tab || 0,
                total           : 0,
                page            : 0,
                pageNum         : 100,
                pageCount       : 0,
                totalPage       : 0,
                loading         : false,
                finished        : false,
                expertList      : [],
                keyword         : this.$route.query.keyword || "",
                barTop          : inMobile() ? 44 : 65,
                tabid           : 0
            }
        },
        computed : {
            ...mapState("jianding", ["categoryTabs"]),
            ...mapGetters("jianding", ["getAppraisersList"]),
            appraiserList(){
                return this.getAppraisersList(0)
            }
        },
        components : {
        },
        methods : {
            ...mapActions("jianding", ["loadAppraisersList"]),
            search(data){
                this.keyword = data.keyword || "";

                this.load(1);
            },
            tabSelect(data){
                //console.log(data)
                this.page = 1;
                let tid = 0
                if(this.active){
                    tid = this.categoryTabs ? this.categoryTabs[this.active-1].id : 0;
                }
                this.tabid = tid;
                if(!this.getAppraisersList(tid).length){
                    this.load(1);
                }
                this.goUrl(data);

            },
            pageChange(page) {
                this.load(page)
            },
            async load(page){
                this.loading = true;
                this.$toast.loading("正在加载");
                let {active, categoryTabs, keyword, pageNum} = this;
                let query = {
                    //tabid                   : tabid,
                    page                    : page || 1,
                    pageNum
                };
                if(active > 0){
                    query.tabid = categoryTabs ? categoryTabs[active-1].id : 0;
                }
                if(keyword){
                    query.keyword = keyword;
                }
                await this.loadAppraisersList(query).then( R => {
                    this.total              = R.total || 0;
                    this.totalPage          = R.total/this.pageNum;
                    this.page               = R.page;
                    this.pageCount          = Math.ceil(R.total/this.pageNum);
                    /*if(this.page > 1){
                        this.expertList     = this.expertList.concat(R.appraisers || []);
                    } else {
                        this.expertList     = R.appraisers || [];
                    }*/
                    if(R.list && R.list.length < this.pageNum){
                        this.finished   = true
                    }
                });
                this.$toast.clear();
                this.loading = false;
            },
            goUrl(){
                let query = {
                    tab : this.active
                };
                if(this.keyword){
                    query.keyword = this.keyword
                }
                this.$router.replace({
                    path: '/list',
                    query
                })
            }
        },
        mounted() {
            this.load(1);
            if(this.$refs.main){
                setTimeout(()=>{
                    this.barTop = document.querySelector('.topBar').clientHeight; //this.$refs.main.offsetTop-5
                },1000)
            }

        },
        watch : {
            active(nv){
            },
            getAppraisersList : {
                handler(nv){
                    console.log(nv)
                },
                deep : true
            }
        }
    }
</script>